import { ValidationError } from "yup";

const getMessage = (error: unknown) => {
  if (error && Object.hasOwn(error, "response")) {
    return (error as { response: { data: { message: string } } }).response.data
      .message;
  }

  const customError = error as {
    message: string;
  };

  return customError.message;
};

const getYupErrorMessages = (error: unknown) => {
  if (error instanceof ValidationError) {
    const errors: Record<string, string> = {};
    if (error.inner && error.inner.length > 0) {
      error.inner.forEach((e) => {
        if (e.path) errors[e.path] = e.message;
      });
      return errors;
    }
  }
};

export { getMessage, getYupErrorMessages };
